module.exports = __webpack_public_path__ + "img/64.79a22691.jpg";